// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"8e8181b4","456":"5cd360ff"}[chunkId] + ".chunk.css";
};